export default __webpack_public_path__ + "static/media/raze_new.5b6dd47a.png";